var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fixBg"},[_c('div',{staticClass:"pxindBox"},[_c('div',{attrs:{"id":"qrcode"}}),_c('img',{staticClass:"closepxind",attrs:{"src":require("@/assets/img/loginImg/closeRemind.png"),"alt":""},on:{"click":_vm.closeRemindBox}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }